import { zIndex } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const FullWidthSplitButtonWrapper = styled.div`
  & > * > * {
    width: 100%;
  }

  & button:first-of-type {
    flex: 1;
  }
`

/**
 * Workaround for the hardcoded z-index in the Lumen Menu component.
 * Remove once a proper solution is implemented: https://shinetools.slack.com/archives/C0A6VSTAN75/p1783079059069579
 */
export const lumenMenuStackingFix = css`
  [class^='_menu_'],
  [class*=' _menu_'] {
    z-index: ${zIndex.Tooltip} !important;
  }
`
